import axios from 'axios';
import { userDevice } from './until';
import EXPPopupJs from '../../components/common/exp-popupjs';
import { handlePharmcareError } from './handlePharmcareError';
import { useTranslation } from 'react-i18next';
import { OptionsProps, StandardResponse } from '.';

export const useGET = () => {
    const BASE_URL = process.env.REACT_APP_API_URL;
    const { t, i18n } = useTranslation(['common']);

    const GET = <T = any>(path: string, options: OptionsProps = {}) => {
        return new Promise<StandardResponse<T>>((resolve, reject) => {
            axios({
                headers: {
                    'Content-Type': 'application/json',
                    'User-Device': userDevice(),
                    // Multiple types, weighted with the quality value syntax:
                    // Accept-Language: fr-CH, fr;q=0.9, en;q=0.8, de;q=0.7, *;q=0.5
                    'Accept-Language': i18n.language.toLowerCase(), // 'en' | 'th'
                    'Referer-Path': window.location.pathname,
                    ...options.headers,
                },
                method: 'get',
                url: `${BASE_URL}${path}`,
                data: '',
            })
                .then((res) => res.data)
                .then((json: StandardResponse<T>) => {
                    if (json.statusCode >= 301) {
                        handlePharmcareError(json, reject);
                    } else {
                        resolve(json);
                    }
                })
                .catch((error) => {
                    if (axios.isAxiosError(error)) {
                        // Axios-specific error (can access status, response, etc.)
                        console.error('Axios Error:', error.response?.data || error.message);
                        reject({ isError: true, isNoPopup: false });
                    } else {
                        // Non-Axios error (like network failure)
                        EXPPopupJs.alert({
                            icon: 'warning',
                            title: 'เกิดข้อผิดพลาด',
                            message: error,
                            buttons: [
                                {
                                    label: 'ตกลง',
                                    action: ({ close }) => {
                                        reject({ ...error, isNoPopup: false });
                                        close();
                                    },
                                },
                            ],
                        });
                    }
                });
        });
    };

    return GET;
};
